import { DashboardData } from '@/types/Backoffice';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type DashboardSlice = {
  dashboardData: DashboardData;
};

const initialState = {
  dashboardData: {},
} as DashboardSlice;

const dashboard = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardData(state, { payload: data }: PayloadAction<DashboardData>) {
      state.dashboardData = data;
    },
  },
});

export const { setDashboardData } = dashboard.actions;
export default dashboard;
